// Built @Wed, 27 Dec 2023 03:56:16 GMT
import { Collector } from "byted-tea-sdk";
import XGPlayerAppLogger from "./logger.js";
XGPlayerAppLogger.TEA_ID = 1300;
XGPlayerAppLogger.Collector = Collector;
function xgVodLogger(args) {
  if (args && args.player) {
    var config = args.player.config.vodLogOpts || {};
    args.player.vodLogger = new XGPlayerAppLogger(args.player, config);
    args.player.plugins.xgVodLogger = args.player.vodLogger;
  } else {
    this.vodLogger = new XGPlayerAppLogger(this, this.config.vodLogOpts || {});
  }
}
xgVodLogger.pluginName = "__xgVodLogger";
xgVodLogger.playerConfig = {};
xgVodLogger.Collector = Collector;
xgVodLogger.setABSdkVersion = function(value) {
  XGPlayerAppLogger.AB_SDK_VERSION = value;
};
export {
  xgVodLogger as default
};
